module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-box"
  }, [_c('header', {
    staticClass: "c-box__heading",
    on: {
      "click": _vm.toggleVariationInfo
    }
  }, [_c('span', {
    staticClass: "check-box",
    class: _vm.selectClass,
    on: {
      "click": _vm.select
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "u-floatRight",
    class: _vm.toggleIconClass()
  }), _vm._v(" "), (_vm.variation.status && _vm.variation.status !== 'sending') ? _c('span', {
    staticClass: "badge u-floatRight",
    class: _vm.variation.status
  }, [_vm._v(_vm._s(_vm.$t(_vm.variation.status).label))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "c-box__body"
  }, [_c('div', {
    staticClass: "c-box__inner"
  }, [_c('panel', {
    attrs: {
      "title": "Informações da variação"
    }
  }, [_c('variation-attributes', {
    attrs: {
      "productId": _vm.productId,
      "variation": _vm.variation,
      "fromModule": _vm.fromModule
    }
  })], 1), _vm._v(" "), (_vm.category.variations_attributes.length) ? _c('panel', {
    attrs: {
      "title": "Atributos"
    }
  }, [_c('general-attributes', {
    attrs: {
      "product": _vm.variation,
      "attributes": _vm.category.variations_attributes
    }
  }), _vm._v(" "), _c('image-variation', {
    attrs: {
      "variation": _vm.variation
    }
  })], 1) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.variationTitle()))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6193b2a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/variation/Multi.vue
// module id = 3225
// module chunks = 0